import { DuplicateFlagMatchReason } from '../generated/enums.gen';

// Duplicate-donor resolution — the treasurer-facing contract for the inline
// ledger resolve panel (DuplicateContactFlagController's list, dismiss
// and merge). A duplicate only matters at filing
// (it understates a donor's totals / limit math), so the treasurer resolves it
// BEFORE filing: Merge two split donor records into one, or Dismiss the pair as
// genuinely-different. Wire enums are engineer-facing PascalCase strings; the
// render boundary translates them to plain copy (per `feedback_treasurer_first_copy`).

/** Treasurer-facing copy for the match reason (translated at the render boundary). */
export const duplicateFlagMatchReasonLabel: Record<DuplicateFlagMatchReason, string> = {
  Email: 'Same email',
  NameAndAddress: 'Same name & address',
  Name: 'Same name',
};
